import { LoaderCircleIcon } from 'lucide-react';

export default function BtnLoader() {
  return (
    <div className="animate-spin">
      <LoaderCircleIcon />
    </div>
  );
}
